import TipsForm from "@/components/feature/TipsForm";

const steps = [
  { icon: "ri-edit-2-line", title: "写下你看到的", desc: "时间、地点、经过，越具体越好，不必讲究文笔。" },
  { icon: "ri-search-eye-line", title: "编辑交叉核实", desc: "我们会比对公开信息与其他来源，确认节点是否站得住。" },
  { icon: "ri-git-commit-line", title: "补进时间线", desc: "核实通过后，节点会标注来源类型，进入对应事件的时间线。" },
];

export default function TipsSection() {
  return (
    <section id="tips" className="w-full px-5 md:px-10 py-14 md:py-20 bg-background-100 scroll-mt-24">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">
        <div className="lg:w-[42%]">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
            <span className="w-5 h-px bg-primary-400" />
            线索通道
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            你手里的细节，可能正是缺失的那一环
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            很多事件的时间线之所以不完整，是因为关键的当事人视角没有被记录。如果你正好在场，
            或者掌握可以核对的公开来源，欢迎告诉我们。
          </p>

          <ol className="mt-7 space-y-5">
            {steps.map((step, index) => (
              <li key={step.title} className="flex gap-4">
                <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-primary-600">
                  <i className={`${step.icon} text-lg`} />
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-foreground-950">
                    {index + 1}. {step.title}
                  </p>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-7 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3.5 text-xs leading-relaxed text-accent-900">
            <i className="ri-information-line mr-1.5" />
            我们不会公开你的联系方式；若线索暂无法核实，也会回复说明原因。
          </div>
        </div>

        <div className="lg:w-[58%]">
          <TipsForm />
        </div>
      </div>
    </section>
  );
}